import http from '@/http'

export function apiGetTranslations(params) {
  return http({
    url: '/api/translations',
    method: 'get',
    params: params
  })
}

export function apiPostTranslations(data) {
  return http({
    url: '/api/translations',
    method: 'post',
    data
  })
}

export function apiDeleteTranslations(data) {
  return http({
    url: '/api/translations',
    method: 'delete',
    data
  })
}


